import { Component, ElementRef, ViewChild} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CaptchaService } from '../../../../../shared/services/captcha.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-msmepreviewpage',
  templateUrl: './msmepreviewpage.component.html',
  styleUrl: './msmepreviewpage.component.css'
})
export class MsmepreviewpageComponent {
  PersonalPreviewData: any;
  captcha!: string;
  captchaError: boolean = false;
  captchaSuccess: boolean = false;
  certificateLink: string | null = null;
  documents: { name: string, file: File | null }[] = [];
  documentLinks: (string | null)[] = [];

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;



  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private captchaService: CaptchaService,
    private toastrService: ToastrService,
    private apiService: ApiService) { }

  previewForm = new FormGroup({   
    termsConditionAccepted: new FormControl('', [Validators.required]),
    thirdPartyUndertaking: new FormControl('', [Validators.required]),
    captcha: new FormControl('', [Validators.required,])
  })

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.scrollContainer.nativeElement.scrollTop = 0; // Scroll to top of container
      }
    });
    this.route.paramMap.subscribe(params => {
      this.PersonalPreviewData = history.state.formData;
      this.initializeDocuments();
    });

    if (this.PersonalPreviewData?.udyamCertificateFile instanceof File) {
      this.certificateLink = URL.createObjectURL(this.PersonalPreviewData.udyamCertificateFile);
    }

    this.generateCaptcha();
  }


  SaveMSMEUser() {
    const userinput = this.previewForm.controls.captcha.value as string;
    if (this.captchaService.validateCaptcha(userinput, this.captcha))
    {
      if (!this.previewForm.valid) {
        this.toastrService.error("You must agree to the Terms & Conditions before submitting.");
        return;
      }

      // Create a FormData object
      const formData = new FormData();

      const excludedKeys = ['UdyamCertificateFile', 'captcha']; // Add any other keys you want to exclude

      // Append form control values dynamically
      Object.keys(this.previewForm.value).forEach(key => {
        const value = this.previewForm.get(key)?.value;
        if (value !== null && !excludedKeys.includes(key)) {
          formData.append(key, value);
        }
      });

      Object.keys(this.PersonalPreviewData).forEach(key => {
        const value = this.PersonalPreviewData[key];
        if (value !== null && !excludedKeys.includes(key)) {
          if (Array.isArray(value)) {
            // If the value is an array, append each item individually
            value.forEach((item, index) => {
              // If the item is an object, you might want to stringify it or handle its properties
              if (typeof item === 'object') {
                Object.keys(item).forEach(subKey => {
                  formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
                });
              } else {
                // For primitive types, you can just append them
                formData.append(`${key}[${index}]`, item);
              }
            });
          } else {
            formData.append(key, value);
          }
        }
      });

      // Append the file
      if (this.PersonalPreviewData?.UdyamCertificateFile) {
        formData.append('UdyamCertificateFile', this.PersonalPreviewData.UdyamCertificateFile, this.PersonalPreviewData.UdyamCertificateFile.name);
      }

      // Append documents (if any) to FormData
      if (this.PersonalPreviewData?.documents && this.PersonalPreviewData.documents.length > 0) {
        this.PersonalPreviewData.documents.forEach((doc: { name: string, file: File | null }, index: number) => {
          if (doc.file) {
            formData.append(`documents[${index}].name`, doc.name);
            formData.append(`documents[${index}].file`, doc.file, doc.file.name);
          }
        });
      }

      this.apiService.postRequest(API_ENDPOINTS.MSME.SAVEUSER, formData)
        //.pipe(
        //catchError(error => {
        //  let errorMessage = "An error occurred";
        //  if (error.status === 409) {
        //    errorMessage = "User already exists";
        //  } else if (error.status === 400) {
        //    errorMessage = "Bad Request";
        //  }
        //  this.toastrService.error(errorMessage);
        //  return of(null);
        //}))
        .subscribe(response => {
        if (response) {
          this.toastrService.success(response.message);
          this.router.navigateByUrl("/login");
        }
      });
    } else {
      this.captchaError = true;
      this.generateCaptcha();
    }
  }

  gotoUdyamVerify() {
    sessionStorage.clear();
    this.router.navigateByUrl("/login");
  }

  private initializeDocuments(): void {
    if (this.PersonalPreviewData?.documents) {
      // Assuming documents are stored in PersonalPreviewData.documents array
      this.documents = this.PersonalPreviewData.documents.map((doc: { name: string, file: File | null }) => ({
        name: doc.name,
        file: doc.file
      }));

      // Generate Blob URLs for the files
      this.documentLinks = this.documents.map(doc =>
        doc.file instanceof File ? URL.createObjectURL(doc.file) : null
      );
    }
  }

  generateCaptcha(): void {
    this.previewForm.get('captcha')?.setValue('');
    this.captcha = this.captchaService.generateCaptcha();
    this.drawCaptcha();
  }

  drawCaptcha(): void {
    const canvas: HTMLCanvasElement = document.getElementById('captchaCanvas') as HTMLCanvasElement;
    const context = canvas.getContext('2d');
    if (context) {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.font = '30px sans-serif';
      context.fillStyle = '#5e5c5c';
      context.fillText(this.captcha, 10, 35);
    }
  }

  getDocumentName(index: number): string {
    const docKey = `Doc${index + 1}`;  // Generate the property key dynamically (Doc1, Doc2, etc.)
    const doc = this.PersonalPreviewData?.[docKey];  // Access the file object dynamically

    return doc instanceof File ? doc.name : 'Unknown Document';  // Return the name if it's a File, else fallback
  }

  navigateBack() {
    this.router.navigate(['/personaldetails'], { state: { formData: this.PersonalPreviewData, fromPreviewPage: true }});
  }
}
